module.exports = __webpack_public_path__ + "img/injective-5.3a6be946.webp";